export default "__VITE_ASSET__DrF0D2$Z__"